module.exports = __webpack_public_path__ + "img/cx.6f47bd1.svg";